import styled from 'styled-components'

export const StyledCard = styled.div.attrs({
  className: 'card',
})`
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`
